import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {baseFill, baseStroke} from '../shared/partVariants';

interface LeftMiddlePillarProps {
  readonly mode?: PartMode;
  readonly onClick?: () => void;
}

export function LeftMiddlePillar(props: LeftMiddlePillarProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Left Middle Pillar"
      width={50}
      height={30}
      viewBox="0 0 50 30"
      position={{bottom: 33, left: 693}}
    >
      <path
        d="M1 13V29H48.9884V13C49.1585 9.16667 47.559 1 37.7571 1H12.2313C2.02103 1 1 8 1 13Z"
        fill="currentColor"
        className={cn(baseFill())}
      ></path>
      <path
        d="M1 13V29H49V14C49 10 48 0.999998 38 0.999998H12C1 0.999998 1 8.98896 1 13Z"
        stroke="currentColor"
        strokeWidth="2"
        className={baseStroke()}
      />
    </PartSvg>
  );
}
